import { Box, Stack, Typography } from "@mui/material";
import CalendarTodayIcon from "assets/svg/CalendarTodayIcon";
import GraphIcon from "assets/svg/GraphIcon";
import { AxiosResponse } from "axios";
import { commonStyle } from "pages/Dashboard/common.styles";
import { useEffect, useRef, useState } from "react";
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { MonthlyVolumeResponse } from "reduxStore/dataTypes";
import { fetchMonthlyTransactionVolume } from "services/apiService";
import theme, { responsiveFontSize } from "themes/Theme";
import { formatNumber } from "utils/formatter";

const EarningGraph = () => {
  const [monthlyData, setMonthlyData] = useState<any[] | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [noGraphData, setNoGraphData] = useState(true);
  const getYearGraphData = async () => {
    try {
      const response: AxiosResponse<MonthlyVolumeResponse> =
        await fetchMonthlyTransactionVolume();
      if (response && response.status === 200) {
        const converted = Object.entries(response?.data?.data?.monthlyData).map(
          ([month, values]) => ({
            name: month,
            totalTransfer: Number(values.totalTransfer),
            totalReceive: Number(values.totalReceive),
          })
        );
        setNoGraphData(false);
        setMonthlyData(converted);
      }
    } catch (error) {
      setNoGraphData(true);
    }
  };
  useEffect(() => {
    getYearGraphData();
  }, []);

  return (
    <Box ref={containerRef} sx={commonStyle.cardStyle}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        sx={styles.calendarBg}
        gap={1}
        mb={2}
      >
        <GraphIcon />
        <Typography sx={commonStyle.cardTitleText}>
          Transaction Volume
        </Typography>
      </Stack>
      {noGraphData ? (
        <Typography
          sx={{
            height: 280,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.text.secondary,
            fontSize: responsiveFontSize(16),
          }}
        >
          No Data Found
        </Typography>
      ) : (
        <ResponsiveContainer width="100%" height={250}>
          <AreaChart
            width={
              containerRef?.current?.getBoundingClientRect().width
                ? containerRef?.current?.getBoundingClientRect().width
                : 460
            }
            height={250}
            data={monthlyData || []}
            margin={{
              top: 5,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <XAxis dataKey="name" />
            <YAxis tickFormatter={formatNumber} />
            <Tooltip
              formatter={(value: number, name: string) => {
                return [
                  `${value}`,
                  name === "totalTransfer" ? "Total Transfer" : "Total Receive",
                ];
              }}
            />
            <Area
              type="monotone"
              dataKey="totalTransfer"
              stackId="1"
              stroke={theme.palette.primary.main}
              fill={theme.palette.primary.main}
            />
            <Area
              type="monotone"
              dataKey="totalReceive"
              stackId="1"
              stroke={theme.palette.primary.light}
              fill={theme.palette.primary.light}
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
};
export default EarningGraph;
const styles = {
  calendarBg: {
    padding: "5px 8px",
    width: "fit-content",
  },
  calendarText: {
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  earningUnit: {
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    color: theme.palette.primary.main,
  },
  earningValue: {
    fontSize: responsiveFontSize(24),
    fontWeight: 400,
    color: theme.palette.text.primary,
    marginLeft: 1,
  },
  totalEarningText: {
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },
};
